// extracted by css-extract-rspack-plugin
export default {"AssigneeAvatar":"Assignee-module__AssigneeAvatar__jqAmq"};